import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts/highstock";
import React, {useEffect, useState} from "react";
import {parseNumberWithCommaDecimal, round, roundWithComma} from "../../../utils/stringUtil";
import {EmissionService} from "../../../services/cp/EmissionService";
import {toast} from "react-toastify";
import {HighchartsOptionsUtil} from "../../../utils/highchartsOptionsUtil";
import {ExistCpDataConstant} from "../../../constants/cpConstant";
import {ActvScopService} from "../../../services/cp/ActvScopService";
import DashboardLoading from "./DashboardLoading";
import {ResponseResultCode} from "../../../model/response-api";
import NoDataToDisplay from "highcharts/modules/no-data-to-display";
import {DashboardModuleProps} from "../../../model/db/dashboardModuleProps";
import DashboardCard from "./DashboardCard";
NoDataToDisplay(Highcharts);

export default function FacilityGhgsEmissQnt(props: Readonly<DashboardModuleProps>) {
  const todayYear = new Date().getFullYear();
  const [emisRateValue, setEmisRateValue] = useState<any>([]);
  const [scopeEmisValue, setScopeEmisValue] = useState<any>();
  const [emisRateOption, setEmisRateOption] = useState<any>();
  const [chartTotal, setChartTotal] = useState<any>();
  const [chartNmList, setChartNmList] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [existBoundarySetting, setExistBoundarySetting] = useState<any>(null);

  function getSubtitle(type: string = '') {
    const flFontSize = type === 'S' ? '0.6rem' : '0.8rem';
    const slFontSize = type === 'S' ? '0.9rem' : '1.5rem';
    const tlFontSize = type === 'S' ? '0.5rem' : '0.75rem';

    if (chartTotal) {
      return `
        <div style="text-align: center;">
          <span class="donut-tit" style="color: #444; font-size: ${flFontSize}; font-weight: 500;">총 탄소배출량</span>
          <br/>
          <strong style="margin-right: 0.25rem; color: #444; font-size: ${slFontSize}; font-weight: 700;">
            ${chartTotal ? parseNumberWithCommaDecimal(chartTotal) : '0'}
          </strong>
          </br>
          <span class="donut-tit" style="color: #666; font-size: ${tlFontSize}; font-weight: 500;">tCO2eq</span>
        </div>
      `;
    } else {
      return '';
    }
  }

  useEffect(() => {
    const initialize = async () => {
      try {
        const response = await ActvScopService.getInstance().existCpData([ExistCpDataConstant.S]);
        if (response && response.resultCode === ResponseResultCode.Y) {
          if (!response.data?.SETTING) {
            setExistBoundarySetting(false);
            return;
          }
        }
        setExistBoundarySetting(true);
      } catch (e) {
      }
    };
    initialize();
  }, []);

  useEffect(() => {
    if(existBoundarySetting) {
      setIsLoading(true);
      EmissionService.getInstance().getEmissionFacilityStatus(todayYear.toString()).then(function (res: any) {
        let arr;

        if (res.data && res.data.length > 0) {
          arr = res.data.reduce(() => {
            let a = [];
            for (let i = 0; i < res.data.length; i++) {
              a.push(res.data[i].emsnFcltNm);
            }
            return new Set(a);
          }, []);
        } else {
          arr = [];
        }

        if(arr.length === 0 ) {
          setIsLoading(false);
          return;
        }
        function createObjectKV(data: any) {
            let resultValue: any = {};
            const myList = Array.from(data);
            myList.forEach((data: any) => {
              resultValue[data] = {
                scopeNm: data,
                mm1EmsnQnt: 0,
                mm2EmsnQnt: 0,
                mm3EmsnQnt: 0,
                mm4EmsnQnt: 0,
                mm5EmsnQnt: 0,
                mm6EmsnQnt: 0,
                mm7EmsnQnt: 0,
                mm8EmsnQnt: 0,
                mm9EmsnQnt: 0,
                mm10EmsnQnt: 0,
                mm11EmsnQnt: 0,
                mm12EmsnQnt: 0,
                total: 0,
              };
            });
            return resultValue;
          }

        const resultMap = res.data.reduce((acc: any, item: any) => {
            let {
              mm1EmsnQnt,
              mm2EmsnQnt,
              mm3EmsnQnt,
              mm4EmsnQnt,
              mm5EmsnQnt,
              mm6EmsnQnt,
              mm7EmsnQnt,
              mm8EmsnQnt,
              mm9EmsnQnt,
              mm10EmsnQnt,
              mm11EmsnQnt,
              mm12EmsnQnt,
              emsnFcltNm,
            } = item;

            acc[emsnFcltNm].mm1EmsnQnt = (acc[emsnFcltNm].mm1EmsnQnt + mm1EmsnQnt);
            acc[emsnFcltNm].mm2EmsnQnt = (acc[emsnFcltNm].mm2EmsnQnt + mm2EmsnQnt);
            acc[emsnFcltNm].mm3EmsnQnt = (acc[emsnFcltNm].mm3EmsnQnt + mm3EmsnQnt);
            acc[emsnFcltNm].mm4EmsnQnt = (acc[emsnFcltNm].mm4EmsnQnt + mm4EmsnQnt);
            acc[emsnFcltNm].mm5EmsnQnt = (acc[emsnFcltNm].mm5EmsnQnt + mm5EmsnQnt);
            acc[emsnFcltNm].mm6EmsnQnt = (acc[emsnFcltNm].mm6EmsnQnt + mm6EmsnQnt);
            acc[emsnFcltNm].mm7EmsnQnt = (acc[emsnFcltNm].mm7EmsnQnt + mm7EmsnQnt);
            acc[emsnFcltNm].mm8EmsnQnt = (acc[emsnFcltNm].mm8EmsnQnt + mm8EmsnQnt);
            acc[emsnFcltNm].mm9EmsnQnt = (acc[emsnFcltNm].mm9EmsnQnt + mm9EmsnQnt);
            acc[emsnFcltNm].mm10EmsnQnt = (acc[emsnFcltNm].mm10EmsnQnt + mm10EmsnQnt);
            acc[emsnFcltNm].mm11EmsnQnt = (acc[emsnFcltNm].mm11EmsnQnt + mm11EmsnQnt);
            acc[emsnFcltNm].mm12EmsnQnt = (acc[emsnFcltNm].mm12EmsnQnt + mm12EmsnQnt);
            acc[emsnFcltNm].total = (acc[emsnFcltNm].total +
                mm1EmsnQnt +
                mm2EmsnQnt +
                mm3EmsnQnt +
                mm4EmsnQnt +
                mm5EmsnQnt +
                mm6EmsnQnt +
                mm7EmsnQnt +
                mm8EmsnQnt +
                mm9EmsnQnt +
                mm10EmsnQnt +
                mm11EmsnQnt +
                mm12EmsnQnt);
            return acc;
        }, createObjectKV(arr));

        let itemSum: any = 0;

        Object.values(resultMap).forEach((item: any) => {
          itemSum += item.total;
        });

        const transformedResult = Object.values(resultMap).map((item: any) => ({
          name: item.scopeNm,
          y: Number(item.total.toFixed(2)),
        })).sort((a: any, b: any) => b.y - a.y);

          if (res.data) {
            setChartTotal(itemSum.toFixed(2));
          }
          setEmisRateValue(transformedResult);
      }).catch((e) => {
        toast.error("시스템 오류가 발생하였습니다.");
      });
    } else {
      setIsLoading(false);
    }
  }, [existBoundarySetting]);

  useEffect(() => {
    EmissionService.getInstance().getEmissionFacilityStatus(todayYear).then(function (res: any) {
      if(!res?.data) {
        return
      }
      function createObjectKV2(data: any) {
        let resultValue: any = {};
        const myList = Array.from(data);
        myList.forEach((data: any) => {
          resultValue[data] = {
            scope1: {
              scopeNm: data,
              mm1EmsnQnt: 0,
              mm2EmsnQnt: 0,
              mm3EmsnQnt: 0,
              mm4EmsnQnt: 0,
              mm5EmsnQnt: 0,
              mm6EmsnQnt: 0,
              mm7EmsnQnt: 0,
              mm8EmsnQnt: 0,
              mm9EmsnQnt: 0,
              mm10EmsnQnt: 0,
              mm11EmsnQnt: 0,
              mm12EmsnQnt: 0,
              total: 0,
            },
            scope2: {
              scopeNm: data,
              mm1EmsnQnt: 0,
              mm2EmsnQnt: 0,
              mm3EmsnQnt: 0,
              mm4EmsnQnt: 0,
              mm5EmsnQnt: 0,
              mm6EmsnQnt: 0,
              mm7EmsnQnt: 0,
              mm8EmsnQnt: 0,
              mm9EmsnQnt: 0,
              mm10EmsnQnt: 0,
              mm11EmsnQnt: 0,
              mm12EmsnQnt: 0,
              total: 0,
            },
            scope3: {
              scopeNm: data,
              mm1EmsnQnt: 0,
              mm2EmsnQnt: 0,
              mm3EmsnQnt: 0,
              mm4EmsnQnt: 0,
              mm5EmsnQnt: 0,
              mm6EmsnQnt: 0,
              mm7EmsnQnt: 0,
              mm8EmsnQnt: 0,
              mm9EmsnQnt: 0,
              mm10EmsnQnt: 0,
              mm11EmsnQnt: 0,
              mm12EmsnQnt: 0,
              total: 0,
            },
          };
        });
        return resultValue;
      }

      let arr: any = [];
      if (res.data) {
        arr = res.data.reduce(() => {
          let a = [];
          for (let i = 0; i < res.data.length; i++) {
            a.push(res.data[i].emsnFcltNm);
          }
          return new Set(a);
        }, []);
      } else {
        arr = null;
      }

      const resultMap = res.data.reduce((acc: any, item: any) => {
        let {
          scopId,
          mm1EmsnQnt,
          mm2EmsnQnt,
          mm3EmsnQnt,
          mm4EmsnQnt,
          mm5EmsnQnt,
          mm6EmsnQnt,
          mm7EmsnQnt,
          mm8EmsnQnt,
          mm9EmsnQnt,
          mm10EmsnQnt,
          mm11EmsnQnt,
          mm12EmsnQnt,
          emsnFcltNm,
        } = item;

        if (scopId === "연료사용" || scopId === "폐기물소각" || scopId === "공정배출") {
          scopId = "scope1";
        } else if (scopId === "전력 사용시설" || scopId === "열/스팀 사용시설") {
          scopId = "scope2";
        } else {
          scopId = "scope3";
        }

        acc[emsnFcltNm][scopId].mm1EmsnQnt = (acc[emsnFcltNm][scopId].mm1EmsnQnt + mm1EmsnQnt);
        acc[emsnFcltNm][scopId].mm2EmsnQnt = (acc[emsnFcltNm][scopId].mm2EmsnQnt + mm2EmsnQnt);
        acc[emsnFcltNm][scopId].mm3EmsnQnt = (acc[emsnFcltNm][scopId].mm3EmsnQnt + mm3EmsnQnt);
        acc[emsnFcltNm][scopId].mm4EmsnQnt = (acc[emsnFcltNm][scopId].mm4EmsnQnt + mm4EmsnQnt);
        acc[emsnFcltNm][scopId].mm5EmsnQnt = (acc[emsnFcltNm][scopId].mm5EmsnQnt + mm5EmsnQnt);
        acc[emsnFcltNm][scopId].mm6EmsnQnt = (acc[emsnFcltNm][scopId].mm6EmsnQnt + mm6EmsnQnt);
        acc[emsnFcltNm][scopId].mm7EmsnQnt = (acc[emsnFcltNm][scopId].mm7EmsnQnt + mm7EmsnQnt);
        acc[emsnFcltNm][scopId].mm8EmsnQnt = (acc[emsnFcltNm][scopId].mm8EmsnQnt + mm8EmsnQnt);
        acc[emsnFcltNm][scopId].mm9EmsnQnt = (acc[emsnFcltNm][scopId].mm9EmsnQnt + mm9EmsnQnt);
        acc[emsnFcltNm][scopId].mm10EmsnQnt = (acc[emsnFcltNm][scopId].mm10EmsnQnt + mm10EmsnQnt);
        acc[emsnFcltNm][scopId].mm11EmsnQnt = (acc[emsnFcltNm][scopId].mm11EmsnQnt + mm11EmsnQnt);
        acc[emsnFcltNm][scopId].mm12EmsnQnt = (acc[emsnFcltNm][scopId].mm12EmsnQnt + mm12EmsnQnt);
        acc[emsnFcltNm][scopId].total = (acc[emsnFcltNm][scopId].total +
            mm1EmsnQnt +
            mm2EmsnQnt +
            mm3EmsnQnt +
            mm4EmsnQnt +
            mm5EmsnQnt +
            mm6EmsnQnt +
            mm7EmsnQnt +
            mm8EmsnQnt +
            mm9EmsnQnt +
            mm10EmsnQnt +
            mm11EmsnQnt +
            mm12EmsnQnt);
        return acc;
      }, createObjectKV2(arr));
      const transformedResult = Object.values(resultMap).map((item: any) => ({
        name: item.scope1.scopeNm,
        Scope1: item.scope1.total,
        Scope2: item.scope2.total,
        Scope3: item.scope3.total,
      })).sort((a: any, b: any) => (b.Scope1 + b.Scope2 + b.Scope3) - (a.Scope1 + a.Scope2 + a.Scope3));
      setChartNmList(transformedResult.map((item: any) => item.name));
      const scopeData = ["Scope2", "Scope1"].map((scopeName) => ({
        name: scopeName,
        data: transformedResult.map((result: any) => result[scopeName]),
      }));
      setScopeEmisValue(scopeData);
    })
    .catch((error) => {
      toast.error("시스템 오류가 발생하였습니다.");
    });
  }, []);


  useEffect(() => {
    const drawEmisRateOption: any = {
      chart: {
        type: 'pie',
        height: 277,
        spacingTop: 0,
        spacingBottom: 0,
      },
      title: { text: '' },
      exporting: { enabled: false },
      credits: { enabled: false },
      noData: HighchartsOptionsUtil.noData,
      legend: {
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'middle',
        borderWidth: 0,
        symbolWidth: 0,
        symbolHeight: 0,
        symbolPadding: 0,
        itemMarginTop: 5,
        itemMarginBottom: 5,
        width: 350,
        useHTML: true,
        labelFormatter: function(this: any) {
          return `
            <div style="width: 15rem; display: flex; justify-content: space-between; align-items: center;">
              <span style="font-size: 0.75rem; color: #555;"><span style="color: ${this.color};">●&nbsp;</span>${this.name}</span>
              <span style="font-size: 0.75rem; color: #666;"><span style="font-size: 0.75rem; color: #333; font-weight: 500;">${parseNumberWithCommaDecimal(this.y)}</span> tCO2eq</span>
            </div>
          `;
        },
      },
      tooltip: {
        formatter: function (this: any) {
          return `<span style="color: ${this.color};">●&nbsp;</span>${this.point.name}: <strong style="font-size: 0.75rem;">${roundWithComma(this.point.y, 2)}</strong>tCO2eq (${round(this.point.percentage, 2)}%)`;
        },
        style: {
          fontSize: '0.75rem'
        }
      },
      subtitle: {
        align: 'center',
        verticalAlign: 'middle',
        x: -183,
        useHTML: true,
        text: getSubtitle(),
      },
      plotOptions: {
        series: {
          allowPointSelect: true,
          cursor: "pointer",
          showInLegend: true,
          borderWidth: 0.5,
          borderRadius: 0,
          innerSize: "70%",
          dataLabels: {
            useHTML: true,
            enabled: true,
            distance: -15,
            formatter(this: any) {
              return (
                `<div style="text-align:center;">
                  <span class="bar-graph-color-num" style="position:relative;display:inline-block;margin-top:5px;padding:2px 5px;font-weight:400;border-radius:15px;overflow:hidden;background: ${this.color}">
                    <span style="position:relative;display:block;z-index:1;color:#fff;font-size:.7rem;font-weight:600;">
                      ${round(this.percentage, 2)}%
                    </span>
                    <em style="position:absolute;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.3);"></em>                        
                  </span>
                </div>`
              );
            },
          },
        },
      },
      colors: HighchartsOptionsUtil.webPortalColors,
      series: [
        {
          name: "시설별 배출량 비율",
          type: "pie",
          data: emisRateValue.length > 0 ? emisRateValue : [{name:"데이터 없음", y:0}] ,
          borderWidth: emisRateValue.length === 0 ? 0.5 : 0,
        },
      ],
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 500,
            },
            chartOptions: {
              subtitle: {
                x: 0,
                y: -43,
                text: getSubtitle('S')
              },
              noData: HighchartsOptionsUtil.noDataResponsive,
              legend: {
                layout: 'vertical',
                align: 'center',
                verticalAlign: 'bottom',
                width: 300,
              },
            }
          },
        ],
      },
    };

    setEmisRateOption(drawEmisRateOption);
    setIsLoading(false);
  }, [emisRateValue]);

  return (
    <DashboardCard
      title="시설별 배출량"
      isConfigMode={props.isConfigMode ?? false}
      moreButtonVisible={true}
      moreButtonUrl="/pc/gas/facility"
      dashboardConfig={props.dashboardConfig}
    >
      <DashboardLoading isLoading={isLoading} />
      {/*{!existBoundarySetting ? (*/}
      {/*  <DashboardNoData*/}
      {/*    message="탄소플래너 운영경계를 설정하세요."*/}
      {/*    link={{text: '감축목표 설정하기', to: '/cp/roadmap/reduceGoal'}}*/}
      {/*  />*/}
      {/*) : (*/}
        <div className="chart">
          {emisRateOption && (
            <HighchartsReact highcharts={Highcharts} options={emisRateOption}/>
          )}
        </div>
      {/*)}*/}
    </DashboardCard>
  )
}